import { AnimalModel } from 'src/app/modules/animals/models/animal.model';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AnimalAddService, OriginContactEntry } from "../services/animal-add.service";
import { ConfirmationService, MenuItem } from "primeng/api";
import { AnimalFilter } from "../animal-filters/animal-filter.model";
import { AnimalService } from "../services/animal.service";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AnimalCategoryModel } from "../models/animal-category.model";
import { AnimalGenderModel } from "../models/animal-gender.model";
import { AnimalCoatTypeModel } from "../models/animal-coat-type.model";
import { AnimalTypeModel } from "../models/animal-type.model";
import { debounceTime, distinctUntilChanged, filter, map, Subject, take, takeWhile, tap } from "rxjs";
import { CompetentAuthorityModel } from "../../../shared/models/competent-authority.model";
import { PersonTitleModel } from "../../../shared/models/person-title.model";
import { ToastService } from "../../../shared/services/toast.service";
import { TranslocoService } from "@jsverse/transloco";
import { AnimalOriginReasonForTransfer } from "../models/animal-origin-reason-for-transfer.enum";
import { AnimalCharacteristicsModel } from "../models/animal-characteristics.model";
import { AnimalSheltersRepository } from '../../../shared/states/animal-shelter.repository';
import { AnimalRepository, AnimalSearchFilters } from "../states/animal.repository";
import { HelperService } from "../../../shared/services/helper.service";
import { AnimalCategory } from '../models/animal-category.enum';
import { AnimalType } from '../models/animal-type.enum';
import { ContactModel } from '../../contact/models/contact.model';
import { WaitingDialogService } from 'src/app/shared/services/waiting-dialog.service';
import { DatePipe } from '@angular/common';
import { CompetentAuthoritiesRepository } from 'src/app/shared/states/competent-authorities.repository';
import { AnimalOriginModel } from '../models/animal-origin.model';
import { CareCondition, NutritionCondition, TemperamentCondition } from '../models/body-condition-score.model';
import { FoundStatus } from '../models/found-status.enum';
import { FoundReportPdfRepository } from '../states/pdf.repository';
import { FoundReportPreviewBuilderService } from '../services/found-report-preview-builder.service';
import { SecuringReportPreviewBuilderService } from '../services/securing-report-preview-builder.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AnimalContactTypeEnum } from '../models/contact-type.enum';
import { FoundProcessSharedInput } from 'src/app/shared/components/duplicate-animals/duplicate-animals.component';
import { OriginContactType, OriginContactRef, OriginContactVm, OriginContactTypeOption } from '../models/origin-contact.model';
import { UserRepository } from '../../user/states/user.repository';
import { User } from '../../user/models/user.model';

export { OriginContactType, OriginContactRef, OriginContactVm } from '../models/origin-contact.model';

@Component({
  selector: 'app-animal-add-dialog',
  templateUrl: './animal-add-dialog.component.html',
  styleUrls: ['./animal-add-dialog.component.scss'],
  standalone: false
})
export class AnimalAddDialogComponent implements OnInit, OnDestroy {
  alive: boolean = true;
  visible: boolean = false;
  items: MenuItem[] = [];
  activeTabIndex: number = 0;
  activeTabIndexLength: number = 0;
  selectedCategory: AnimalFilter | undefined;

  formGroup: FormGroup;
  formGroupStatus$: any;

  categoryFilters: AnimalFilter[] = [];
  animalTypeOptions: AnimalTypeModel[] = [];
  allAnimalTypes: AnimalTypeModel[] = [];
  animalCategoryOptions: AnimalCategoryModel[] = [];
  coatTypeOptions: AnimalCoatTypeModel[] = [];
  genderOptions: AnimalGenderModel[] = [];
  formSubmitted: boolean = false;
  originCompetentAuthorityOptions: CompetentAuthorityModel[] = [];
  presentShelterStaffOptions: User[] = [];
  originPersonSalutationOptions: PersonTitleModel[] = [];
  animalShelterId: number | undefined;
  characteristicsOptions: AnimalCharacteristicsModel[] | undefined;
  searchTerm: string = '';
  searchTermChanged = new Subject<string>();
  animalSearchResult: AnimalModel[] = [];
  selectedMother: AnimalModel | null = null;
  resumeAnimal: AnimalModel = {} as AnimalModel;
  resumeAnimalSteps: boolean = false;
  reasonGivenSet: string = '';
  reasonsForTransfer = AnimalOriginReasonForTransfer;
  isYearOnlyFlag = false;

  showCompetentAuthorityDialog: any;

  weightInput: number | null = null;
  weightInputInvalid: boolean = false;

  skipCloseOnHide = false;
  duplicateAnimalDialogVisible = false;
  duplicateOrigin: AnimalOriginModel | null = null;

  foundDuplicateMode = false;
  private pendingFoundDuplicate = false;
  foundDuplicateAnimal: AnimalModel | null = null;
  foundDuplicateOrigin: AnimalOriginModel | null = null;
  foundDuplicateShared: FoundProcessSharedInput | null = null;
  animal: AnimalModel | null = null;

  prefillTransponderNumber: string | null = null;
  prefillBookNumber: string | null = null;
  prefillName: string | null = null;

  foundAnimalMode: boolean = false;
  securedByPoliceMode: boolean = false;
  // Bestimmt die Schritte vor dem Abgabegrund: neues Tier, Wiederaufnahme
  // oder bestehendes Fundtier aus der Suche (ohne Allgemein/Abgabegrund).
  private wizardEntry: 'new' | 'resume' | 'foundExisting' = 'new';

  resumeDuplicateDialogVisible = false;
  resumeDuplicateCandidates: AnimalModel[] = [];
  resumeDuplicateSourceField: string | null = null;

  ownerContactIsGiven: boolean = false;

  protected readonly FoundStatus = FoundStatus;
  bodyCondition: {
    care: string[];
    nutrition: NutritionCondition | null;
    temperament: string[];
  } = {
      care: [],
      nutrition: null,
      temperament: []
    };
  reportPreviewBlob: any;
  isLoadingPreview = false;
  sendFoundReportDialogVisible: boolean = false;
  sendFoundReportOriginId: number | null = null;
  sendFoundReportContacts: ContactModel[] = [];


  originContacts: OriginContactVm[] = [];
  // null = kein Panel offen. PrimeNG setzt beim Zuklappen des offenen Panels
  // undefined ins Signal, das (valueChange)-Binding schreibt das durch.
  activeOriginContactPanelIndex: string | null = '0';

  originContactTypeOptions: OriginContactTypeOption[] = [
    { label: '-', value: null },
    { label: 'Finder', value: AnimalContactTypeEnum.FINDER },
    { label: 'Besitzer', value: AnimalContactTypeEnum.OWNER },
    { label: 'Abgebender', value: AnimalContactTypeEnum.GIVER },
    { label: 'Abholberechtigt', value: AnimalContactTypeEnum.AUTHORIZED_PICKUP },
    { label: 'Weitere beteiligte Person', value: AnimalContactTypeEnum.ADDITIONAL_PARTY },
  ];

  getOriginContactTypeLabel(type: OriginContactType): string {
    return this.originContactTypeOptions.find(x => x.value === type)?.label ?? type;
  }

  trackByOriginContact = (index: number, vm: OriginContactVm) =>
    `${index}-${vm.ref.type}-${vm.contact?.id ?? 'new'}`;


  constructor(
    public animalService: AnimalService,
    private readonly _animalAddService: AnimalAddService,
    private readonly _toast: ToastService,
    private readonly _translateService: TranslocoService,
    private readonly _animalSheltersRepository: AnimalSheltersRepository,
    private cdr: ChangeDetectorRef,
    private readonly _animalRepository: AnimalRepository,
    private readonly _helperService: HelperService,
    private readonly _waittingDialogService: WaitingDialogService,
    private readonly datePipe: DatePipe,
    private readonly _competentAuthoritiesRepository: CompetentAuthoritiesRepository,
    private readonly _userRepository: UserRepository,
    private readonly _foundReportPdfRepo: FoundReportPdfRepository,
    private readonly _foundPreviewBuilder: FoundReportPreviewBuilderService,
    private readonly _securingPreviewBuilder: SecuringReportPreviewBuilderService,
    private sanitizer: DomSanitizer,
    private readonly _confirmationService: ConfirmationService
  ) {
    this.formGroup = new FormGroup(
      {
        animalShelter: new FormControl<string | null>(null),
        type: new FormControl<AnimalTypeModel | null>(null, Validators.required),
        category: new FormControl<AnimalCategoryModel | null>(null, Validators.required),
        sex: new FormControl<string | null>(null, Validators.required),
        name: new FormControl<string | null>(null),
        nameOld: new FormControl<string | null>(null),
        nameNew: new FormControl<string | null>(null),
        birthApprox: new FormControl<boolean>(false),
        birthdayType: new FormControl<boolean | null>(false),
        birthYear: new FormControl<Date | null>(null),
        birthday: new FormControl<Date | null>(null),
        birthPlace: new FormControl<string | null>(null),
        breed: new FormControl<string | null>(null, Validators.required),
        weight: new FormControl<number | null>(null),
        coatType: new FormControl<AnimalCoatTypeModel[]>([]),
        coatColor: new FormControl<string | null>(null),
        specialInformation: new FormControl<string | null>(null),
        badge: new FormControl<string | null>(null),
        specialNotice: new FormControl<string | null>(null),
        transponderNumber: new FormArray<FormControl>([]),
        oldBookNumberList: new FormArray<FormControl>([]),
        lifeNumber: new FormControl<string | null>(null),
        ringNumber: new FormControl<string | null>(null),
        petPassportNumber: new FormControl<string | null>(null),
        equinePassportNumber: new FormControl<string | null>(null),
        earTag: new FormControl<string | null>(null),
        tattoo: new FormControl<string | null>(null),
        tattooLocation: new FormControl<string | null>(null),
        //Origin
        originCompetentAuthority: new FormControl<string | null>(null),
        dateOfReceipt: new FormControl<Date | null>(null),
        foundDateTime: new FormControl<Date | null>(null),
        originSpecialInformation: new FormControl<string | null>(null),
        originCareCondition: new FormControl<string[]>([]),
        originBcsNutrition: new FormControl<string | null>(null),
        originTemperament: new FormControl<string[]>([]),
        originOtherComments: new FormControl<string | null>(null),
        originLocation: new FormControl<string | null>(null),
        originType: new FormControl<string | null>(null),
        finderSignature: new FormControl<string | null>(null),
        employeeSignature: new FormControl<string | null>(null),
        foundSituation: new FormControl<string | null>(null),

        reportPdfPath: new FormControl<string | null>(null),
        signatureLocation: new FormControl<string | null>(null),
        signatureDate: new FormControl<Date | null>(new Date()),

        pickupUserName: new FormControl<string | null>(null),
        pickUpDateTime: new FormControl<Date | null>(null),
        foundStatus: new FormControl<FoundStatus | null>(null),

        consentToShareWithOwner: new FormControl<boolean>(false),
        careCondition: new FormControl<string[]>([]),
        bcsNutrition: new FormControl<string | null>(null),
        temperament: new FormControl<string[]>([]),

        // Behörtliche Sicherung (secured_by_police)
        handoverAuthority: new FormControl<CompetentAuthorityModel | null>(null),
        handoverResponsibleContact: new FormControl<ContactModel | null>(null),
        ownerPresentAtHandover: new FormControl<boolean>(false),
        securingReason: new FormControl<string | null>(null),
        securingReasonOther: new FormControl<string | null>(null),
        incidentCourse: new FormControl<string | null>(null),
        operationDescription: new FormControl<string | null>(null),
        biteVictimType: new FormControl<string | null>(null),
        biteVictimGender: new FormControl<string | null>(null),
        biteVictimAge: new FormControl<number | null>(null),
        housingConditionsDescription: new FormControl<string | null>(null),
        otherAnimalsLeftOnSite: new FormControl<boolean>(false),
        otherAnimalsDescription: new FormControl<string | null>(null),
        handedOverEquipment: new FormControl<string | null>(null),
        handoverHealthStatus: new FormControl<string[]>([]),
        needsImmediateVetCare: new FormControl<boolean>(false),
        healthDescription: new FormControl<string | null>(null),
        behaviourAtHandover: new FormControl<string | null>(null),
        operationStartAt: new FormControl<Date | null>(null),
        operationEndAt: new FormControl<Date | null>(null),
        handoverPartySignature: new FormControl<string | null>(null),
        presentShelterStaff: new FormControl<number[]>([]),
      },
      {
        updateOn: 'change',
      }
    );

    const transponderArray = this.formGroup.get('transponderNumber') as FormArray;
    if (transponderArray.length === 0) {
      transponderArray.push(new FormControl(''));
    }
    const oldBookNumberArray = this.formGroup.get('oldBookNumberList') as FormArray;
    if (oldBookNumberArray.length === 0) {
      oldBookNumberArray.push(new FormControl(''));
    }

    this.formGroup.get('castratedDate')?.valueChanges.subscribe(() => {
      this.onCastratedDatesChange();
    });

    this.formGroup.get('chemicalCastratedDate')?.valueChanges.subscribe(() => {
      this.onCastratedDatesChange();
    });
  }


  ngOnInit(): void {
    const activeAnimalShelter = this._animalSheltersRepository.getActiveAnimalShelter();
    if (activeAnimalShelter) {
      this.animalShelterId = activeAnimalShelter.id;
      this._competentAuthoritiesRepository.getCompetentAuthoritiesByShelterId(activeAnimalShelter.id).pipe(take(1)).subscribe((competentAuthorities) => {
        this.originCompetentAuthorityOptions = competentAuthorities;
        this.cdr.detectChanges();
      });
      this._userRepository.loadUsersByShelter(activeAnimalShelter.id).pipe(take(1)).subscribe((users) => {
        this.presentShelterStaffOptions = users;
        this.cdr.detectChanges();
      });
    }
    this.updateSteps();

    this.originPersonSalutationOptions = this._helperService.getSalutationOptions();

    this.formGroupStatus$ = this.formGroup.statusChanges.pipe(
      map((status) => status)
    );

    this.categoryFilters = this.animalService.getFilterCategories();
    this.allAnimalTypes = this.animalService.getAnimalTypes();
    this.animalCategoryOptions = this.animalService.getAnimalCategories();
    this.genderOptions = this.animalService.getGenderOptions();
    this.coatTypeOptions = this.animalService.getCoatTypes();
    this.characteristicsOptions = this.animalService.getCharacteristics();
    this.visible = true;

    this.searchTermChanged.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeWhile(() => this.alive),
      tap(term => { if (term.length === 0) this.animalSearchResult = []; }),
      filter(term => term.length > 1)
    ).subscribe(term => {
      this._animalRepository.searchAnimals(term).pipe(take(1)).subscribe(results => {
        this.animalSearchResult = results;
      });
    });

    this.weightInput = null;
    const weightVal = this.formGroup.get('weight')?.value;
    if (weightVal !== null && weightVal !== undefined) {
      this.weightInput = this.formatWeightInput(weightVal);
    }

    this._animalAddService.resumeAnimal$.pipe(takeWhile(() => this.alive)).subscribe((animal) => {
      if (animal) {
        this.resumeAnimalStep(animal);
      } else {
        this.resumeAnimal = {} as AnimalModel;
        this.resumeAnimalSteps = false;
      }
      this.cdr.detectChanges();
    });

    this._animalAddService.addDialogVisible.pipe(takeWhile(() => this.alive)).subscribe((open) => {
      this.visible = open;
      if (!open) {
        this._animalAddService.setResumeAnimal(null);
        this._animalAddService.setPrefill(null);

        this.searchTerm = '';
        this.prefillTransponderNumber = null;
        this.prefillBookNumber = null;
        this.prefillName = null;

        this.resumeAnimal = {} as AnimalModel;
        this.resumeAnimalSteps = false;
        this.activeTabIndex = 0;

        this.cdr.detectChanges();
        return;
      }

      if (!this.resumeAnimalSteps && (this.prefillTransponderNumber || this.prefillBookNumber || this.prefillName)) {
        setTimeout(() => {
          this.addNewAnimalStep();
          this.cdr.markForCheck();
        }, 0);
      }

      this.cdr.detectChanges();
    });


    this.formGroup.get('foundStatus')?.valueChanges
      .pipe(takeWhile(() => this.alive))
      .subscribe(status => {
        const s = status as FoundStatus | null;
        this.updateFoundStatusValidators(s);
      });

    this.updateFoundStatusValidators(this.formGroup.get('foundStatus')?.value);
    this._animalAddService.prefill$
      .pipe(takeWhile(() => this.alive))
      .subscribe(prefill => {
        if (!prefill) return;

        const value = (prefill.value ?? '').trim();
        if (!value) return;

        this.searchTerm = value;

        this.prefillTransponderNumber = null;
        this.prefillBookNumber = null;
        this.prefillName = null;

        if (prefill.type === 'transponder') this.prefillTransponderNumber = value;
        if (prefill.type === 'bookNumber') this.prefillBookNumber = value;
        if (prefill.type === 'name') this.prefillName = value;

        if (this.visible && !this.resumeAnimalSteps) {
          if (this.activeTabIndex === 0) {
            Promise.resolve().then(() => {
              this.addNewAnimalStep();
              this.cdr.markForCheck();
            });
          }
        }

        this.cdr.markForCheck();
      });
  }

  closeModal() {
    this._animalAddService.setResumeAnimal(null);
    this._animalAddService.toggleAddDialog(false);
    this.securedByPoliceMode = false;
    this.clearOriginContacts();
    this._animalAddService.setPrefill(null);
    this.prefillTransponderNumber = null;
    this.prefillBookNumber = null;
    this.prefillName = null;
    this.searchTerm = '';
  }

  private createEmptyOriginContact(type: OriginContactType = AnimalContactTypeEnum.GIVER): OriginContactVm {
    return {
      ref: {
        type,
        label: null,
        isPrimary: false,
      },
      contact: {} as ContactModel,
      isExisting: false,
      isValid: false,
    };
  }

  get transponderNumbers(): FormArray {
    return this.formGroup.get('transponderNumber') as FormArray;
  }

  addTransponderNumber() {
    this.transponderNumbers.push(new FormControl(''));
  }

  removeTransponderNumber(index: number) {
    if (this.transponderNumbers.length > 1) {
      this.transponderNumbers.removeAt(index);
    }
  }

  get oldBookNumberList(): FormArray {
    return this.formGroup.get('oldBookNumberList') as FormArray;
  }

  get oldBookNumberControls(): FormControl[] {
    return this.oldBookNumberList.controls as FormControl[];
  }

  get oldBookNumberControlsReversed(): FormControl[] {
    return [...this.oldBookNumberControls].reverse();
  }

  addOldBookNumber(value: string = '') {

    this.oldBookNumberList.push(new FormControl(value));
    this.updateOldBookNumberDisabledStates();
  }

  removeOldBookNumberControl(ctrl: FormControl) {
    const index = this.oldBookNumberList.controls.indexOf(ctrl);
    if (index === -1) return;

    this.oldBookNumberList.removeAt(index);
    this.updateOldBookNumberDisabledStates();
  }

  private updateOldBookNumberDisabledStates(): void {
    const arr = this.oldBookNumberList;
    const lastIndex = arr.length - 1;

    arr.controls.forEach((ctrl, index) => {
      if (index === lastIndex) {
        ctrl.enable({ emitEvent: false });
      } else {
        ctrl.disable({ emitEvent: false });
      }
    });
  }

  private updateFoundStatusValidators(status: FoundStatus | null): void {
    const statusCtrl = this.formGroup.get('foundStatus');
    const timeCtrl = this.formGroup.get('pickUpDateTime');
    const nameCtrl = this.formGroup.get('pickupUserName');

    if (!statusCtrl || !timeCtrl || !nameCtrl) return;

    if (this.foundAnimalMode) {
      statusCtrl.setValidators([Validators.required]);
    } else {
      statusCtrl.clearValidators();
      statusCtrl.setValue(null, { emitEvent: false });
    }
    statusCtrl.updateValueAndValidity({ emitEvent: false });

    timeCtrl.clearValidators();
    nameCtrl.clearValidators();

    if (this.foundAnimalMode && status === FoundStatus.COLLECTED) {
      timeCtrl.setValidators([Validators.required]);
      nameCtrl.setValidators([Validators.required]);
    } else {
      timeCtrl.setValue(null, { emitEvent: false });
      nameCtrl.setValue(null, { emitEvent: false });
    }

    timeCtrl.updateValueAndValidity({ emitEvent: false });
    nameCtrl.updateValueAndValidity({ emitEvent: false });

    this.cdr.markForCheck();
  }


  private updateBcsValidators(): void {
    const care = this.formGroup.get('careCondition');
    const nutri = this.formGroup.get('bcsNutrition');
    const temp = this.formGroup.get('temperament');
    if (!care || !nutri || !temp) return;

    if (this.foundAnimalMode) {
      care.setValidators([Validators.required]);
      nutri.setValidators([Validators.required]);
      temp.setValidators([Validators.required]);
    } else {
      care.clearValidators();
      nutri.clearValidators();
      temp.clearValidators();

      care.setValue([], { emitEvent: false });
      nutri.setValue(null, { emitEvent: false });
      temp.setValue([], { emitEvent: false });
    }

    care.updateValueAndValidity({ emitEvent: false });
    nutri.updateValueAndValidity({ emitEvent: false });
    temp.updateValueAndValidity({ emitEvent: false });

    this.cdr.markForCheck();
  }

  get finderSectionInvalid(): boolean {
    if (!this.foundAnimalMode) return false;

    const statusCtrl = this.formGroup.get('foundStatus');
    if (!statusCtrl) return false;

    const statusInvalid = statusCtrl.invalid;
    const bcsInvalid = !this.isBcsValid();

    const collectedInvalid =
      statusCtrl.value === FoundStatus.COLLECTED
        ? ((this.formGroup.get('pickUpDateTime')?.invalid ?? false) ||
          (this.formGroup.get('pickupUserName')?.invalid ?? false))
        : false;

    return statusInvalid || bcsInvalid || collectedInvalid;
  }

  get bcsCareCtrl(): FormControl<CareCondition[]> {
    return this.formGroup.get('careCondition') as FormControl<CareCondition[]>;
  }

  get bcsNutritionCtrl(): FormControl<NutritionCondition | null> {
    return this.formGroup.get('bcsNutrition') as FormControl<NutritionCondition | null>;
  }

  get bcsTemperamentCtrl(): FormControl<TemperamentCondition[]> {
    return this.formGroup.get('temperament') as FormControl<TemperamentCondition[]>;
  }

  get originBcsCareCtrl(): FormControl<CareCondition[]> {
    return this.formGroup.get('originCareCondition') as FormControl<CareCondition[]>;
  }

  get originBcsNutritionCtrl(): FormControl<NutritionCondition | null> {
    return this.formGroup.get('originBcsNutrition') as FormControl<NutritionCondition | null>;
  }

  get originBcsTemperamentCtrl(): FormControl<TemperamentCondition[]> {
    return this.formGroup.get('originTemperament') as FormControl<TemperamentCondition[]>;
  }

  private applyPrefillToForm(): void {
    if (this.prefillTransponderNumber) {
      const arr = this.formGroup.get('transponderNumber') as FormArray;
      if (arr.length === 0) arr.push(new FormControl(this.prefillTransponderNumber));
      else arr.at(0).setValue(this.prefillTransponderNumber);
    }

    if (this.prefillBookNumber) {
      const arr = this.formGroup.get('oldBookNumberList') as FormArray;
      if (arr.length === 0) arr.push(new FormControl(this.prefillBookNumber));
      else arr.at(arr.length - 1).setValue(this.prefillBookNumber);

      this.updateOldBookNumberDisabledStates?.();
    }

    if (this.prefillName) {
      this.formGroup.get('name')?.setValue(this.prefillName);
    }
  }

  resetAllFormFields(formGroup: FormGroup): void {
    formGroup.reset({
      type: null,
      category: null,
      sex: null,
      name: null,
      nameOld: null,
      birthApprox: false,
      birthdayType: false,
      birthYear: null,
      birthday: null,
      birthPlace: null,
      breed: null,
      // neu
      weight: null,
      coatType: [],
      coatColor: null,
      specialInformation: null,
      badge: null,
      specialNotice: null,
      lifeNumber: null,
      ringNumber: null,
      petPassportNumber: null,
      equinePassportNumber: null,
      earTag: null,
      tattoo: null,
      tattooLocation: null,
      motherId: null,
      originCompetentAuthority: null,
      dateOfReceipt: null,
      foundDateTime: null,
      originSpecialInformation: null,
      originCareCondition: [],
      originBcsNutrition: null,
      originTemperament: [],
      originOtherComments: null,
      originLocation: null,
      foundStatus: null,
      finderSignature: null,
      employeeSignature: null,
      foundSituation: null,
      reportPdfPath: null,
      signatureLocation: null,
      signatureDate: new Date(),

      consentToShareWithOwner: false,
      pickUpDateTime: null,
      pickupUserName: null,
    });
    const transponderArray = formGroup.get('transponderNumber') as FormArray;
    while (transponderArray.length > 0) {
      transponderArray.removeAt(0);
    }
    transponderArray.push(new FormControl(''));
    const oldBookNumberArray = formGroup.get('oldBookNumberList') as FormArray;
    while (oldBookNumberArray.length > 0) {
      oldBookNumberArray.removeAt(0);
    }
    oldBookNumberArray.push(new FormControl(''));

    this.weightInput = null;
    this.weightInputInvalid = false;
    this.isYearOnlyFlag = false;
  }


  resetOriginFields(formGroup: FormGroup): void {
    formGroup.patchValue({
      originCompetentAuthority: null,
      dateOfReceipt: null,
      foundDateTime: null,
      originSpecialInformation: null,
      originCareCondition: [],
      originBcsNutrition: null,
      originTemperament: [],
      originOtherComments: null,
      originLocation: null,
      pickupUserName: null,
      pickUpDateTime: null,
      foundStatus: null,
      finderSignature: null,
      employeeSignature: null,
      foundSituation: null,
      reportPdfPath: null,
      signatureLocation: null,
      signatureDate: new Date()
    });
    this.clearOriginContacts();
  }

  /**
   * Schritte = fester Kopf (je nach Einstieg) + Herkunfts-Schritte (je nach Abgabegrund).
   * Der Kopf ändert sich beim Wechsel des Abgabegrunds nicht, dadurch bleibt
   * der Index stabil und man kann jederzeit bis zum Anfang zurück.
   */
  private updateSteps(): void {
    const head = this.wizardEntry === 'resume'
      ? ['Allgemein', 'Abgabegrund']
      : this.wizardEntry === 'foundExisting'
        ? ['Suche']
        : ['Suche', 'Kategorie', 'Allgemein', 'Abgabegrund'];

    const tail = this.foundAnimalMode
      ? ['Fundtieranzeige', 'PDF', 'Unterschriften']
      : this.securedByPoliceMode
        ? ['Sicherstellung', 'PDF', 'Unterschriften']
        : ['Herkunft'];

    this.items = [...head, ...tail].map(label => ({ label }));
    this.activeTabIndexLength = this.items.length - 1;
  }

  /**
   * Setzt alles zurück, was vom Abgabegrund abhängt, damit nach einem Wechsel
   * keine Werte des vorherigen Grunds im Formular bleiben und mitgesendet werden.
   */
  private resetReasonState(): void {
    this.resetOriginFields(this.formGroup);
    this.resetSecuringFields();
    this.formGroup.patchValue({
      consentToShareWithOwner: false,
      careCondition: [],
      bcsNutrition: null,
      temperament: [],
    }, { emitEvent: false });

    this.formGroup.removeControl('motherId');
    this.formGroup.removeControl('mother');
    this.selectedMother = null;

    this.reportPreviewBlob = null;
    this.reasonGivenSet = '';
    this.formGroup.get('originType')?.setValue(null);
    this.foundAnimalMode = false;
    this.securedByPoliceMode = false;

    this.applyFoundModeState({ pdfRequired: false });
  }

  private resetWizard(): void {
    this.resetReasonState();
    this.resetAllFormFields(this.formGroup);
    this.resumeAnimal = {} as AnimalModel;
    this.resumeAnimalSteps = false;
    this.selectedCategory = undefined;
    this.wizardEntry = 'new';
    this.updateSteps();
    this.activeTabIndex = 0;
    this.cdr.markForCheck();
  }

  private clearSignatures(): void {
    this.formGroup.patchValue({
      finderSignature: null,
      employeeSignature: null,
      handoverPartySignature: null,
    }, { emitEvent: false });
  }

  lastStep() {
    if (this.getTabContent() === 'signatures') {
      // Die Signatur-Pads können gespeicherte Unterschriften nicht wieder anzeigen,
      // daher beim Verlassen verwerfen – sonst würde eine unsichtbare Unterschrift gespeichert.
      this.clearSignatures();
      if (this.foundAnimalMode) {
        this.applyFoundModeState({ pdfRequired: false });
      }
    }

    if (this.activeTabIndex === 0 || this.items[this.activeTabIndex - 1]?.label === 'Suche') {
      this.resetWizard();
      return;
    }

    this.activeTabIndex--;
    this.cdr.markForCheck();
  }

  nextStep() {
    const current = this.getTabContent();

    if (this.foundAnimalMode && current === 'origin') {
      const payload = this._foundPreviewBuilder.build({
        animal: this.resumeAnimalSteps ? this.resumeAnimal : this.formGroup.value,
        formValue: this.formGroup.getRawValue(),
        shelterId: this.animalShelterId!,
        contacts: (this.originContacts ?? [])
          .filter(x => x.isValid && !!x.contact)
          .map(x => ({ contact: x.contact, type: x.ref.type })),
      });

      this.isLoadingPreview = true;
      this.cdr.markForCheck();

      this._foundReportPdfRepo.getPreview(payload).subscribe(res => {
        this.isLoadingPreview = false;
        this.reportPreviewBlob = res;

        this.applyFoundModeState({ pdfRequired: false });
        this.activeTabIndex++;
        this.cdr.markForCheck();
      });

      return;
    }

    if (this.foundAnimalMode && current === 'pdf') {
      this.applyFoundModeState({ pdfRequired: true });
      this.activeTabIndex++;
      return;
    }

    if (this.securedByPoliceMode && current === 'securing') {
      const activeShelter = this._animalSheltersRepository.getActiveAnimalShelter();
      const payload = this._securingPreviewBuilder.build({
        animal: this.resumeAnimalSteps ? this.resumeAnimal : this.formGroup.value,
        formValue: this.formGroup.getRawValue(),
        shelterId: this.animalShelterId!,
        boardMembers: (activeShelter as any)?.boardMembers ?? null,
        contacts: (this.originContacts ?? [])
          .filter(x => x.isValid && !!x.contact)
          .map(x => ({ contact: x.contact, label: x.ref.label ?? null, type: x.ref.type })),
      });

      this.isLoadingPreview = true;
      this.cdr.markForCheck();

      this._foundReportPdfRepo.getSecuringPreview(payload).subscribe(res => {
        this.isLoadingPreview = false;
        this.reportPreviewBlob = res;
        this.activeTabIndex++;
        this.cdr.markForCheck();
      });

      return;
    }

    if (this.securedByPoliceMode && current === 'pdf') {
      this.activeTabIndex++;
      return;
    }

    this.activeTabIndex++;
  }

  isNextStepDisabled(): boolean {
    if (this.foundAnimalMode) {
      const tab = this.getTabContent();

      if (tab === 'origin') {
        return this.finderSectionInvalid || !this.getInvalidFormControls();
      }

      if (tab === 'pdf') {
        return false;
      }
    }

    if (this.securedByPoliceMode) {
      const tab = this.getTabContent();

      if (tab === 'securing') {
        return this.securingSectionInvalid;
      }

      if (tab === 'pdf') {
        return false;
      }
    }

    let isDisabled = false;
    if (
      this.getTabContent() === 'search' ||
      (this.getTabContent() === 'category' && this.selectedCategory === undefined) ||
      (this.getTabContent() === 'reasonForDelivery' && (!this.reasonGivenSet || !this.reasonGivenSet.length))
    ) {
      isDisabled = true;
    }

    if (this.getTabContent() === 'general') {
      return !(
        this.formGroup.get('type')?.valid &&
        this.formGroup.get('category')?.valid &&
        this.formGroup.get('sex')?.valid &&
        this.formGroup.get('breed')?.valid
      );
    }

    return isDisabled;
  }

  addNewAnimalStep() {
    this.resetReasonState();
    this.resetAllFormFields(this.formGroup);
    this.applyPrefillToForm();
    this.wizardEntry = 'new';
    this.updateSteps();
    this.activeTabIndex = 1;
  }

  resumeAnimalStep(animal: AnimalModel) {
    this.resetReasonState();
    this.resumeAnimal = animal;
    this.resumeAnimalSteps = true;
    this.wizardEntry = 'resume';
    this.updateSteps();
    this.activeTabIndex = 0;
    this.resetAllFormFields(this.formGroup);
    const matchingFilter = this.categoryFilters.find(filter => {
      try {
        return this.mapFilterIdToCategory(filter.id) === this.resumeAnimal.category;
      } catch {
        return false;
      }
    });

    if (matchingFilter) {
      this.selectCategory(matchingFilter, false);
    } else {
      try {
        this.onCategoryChange({ value: this.resumeAnimal.category } as any);
      } catch {
      }
    }

    this.formGroup.patchValue(this.resumeAnimal);
    if (this.resumeAnimal.weight ?? null) {
      const w = this.resumeAnimal.weight;

      this.weightInput = w != null
        ? this.formatWeightInput(w / 1000)
        : null;
    } else {
      this.weightInput = null;
    }
    if (this.resumeAnimal.birthday) {
      this.formGroup.get('birthday')?.patchValue(new Date(this.resumeAnimal.birthday));
    }
    this.formGroup.get('name')?.setValue(null);
    this.formGroup.get('nameOld')?.setValue(this.resumeAnimal.name);

    const transponderArray = this.formGroup.get('transponderNumber') as FormArray;

    while (transponderArray.length > 0) {
      transponderArray.removeAt(0);
    }

    const transpondersFromAnimal =
      this.resumeAnimal.transponderNumber && this.resumeAnimal.transponderNumber.length > 0
        ? this.resumeAnimal.transponderNumber = this.resumeAnimal.transponderNumber : [];

    if (transpondersFromAnimal.length === 0) {
      transponderArray.push(new FormControl(''));
    } else {
      transpondersFromAnimal.forEach(v => transponderArray.push(new FormControl(v)));
    }

    const oldBookArray = this.formGroup.get('oldBookNumberList') as FormArray;

    while (oldBookArray.length > 0) {
      oldBookArray.removeAt(0);
    }

    const oldBooksFromAnimal =
      this.resumeAnimal.oldBookNumberList && this.resumeAnimal.oldBookNumberList.length > 0
        ? this.resumeAnimal.oldBookNumberList
        : (this.resumeAnimal.oldBookNumber ? [this.resumeAnimal.oldBookNumber] : []);

    if (oldBooksFromAnimal.length === 0) {
      oldBookArray.push(new FormControl<string | null>(''));
    } else {
      oldBooksFromAnimal.forEach(num => {
        oldBookArray.push(
          new FormControl<string | null>({ value: num, disabled: true })
        );
      });

      oldBookArray.push(new FormControl<string | null>(null));
    }

    this.updateOldBookNumberDisabledStates();
  }

  onDuplicateNumber(field: string, animals: AnimalModel[]): void {
    if (!animals || animals.length === 0) {
      return;
    }

    if (this.resumeAnimalSteps || this.foundAnimalMode) {
      return;
    }

    this.clearOriginContacts();
    this.resumeDuplicateSourceField = field;
    this.resumeDuplicateCandidates = animals;
    this.resumeDuplicateDialogVisible = true;

  }

  private mergeResumeAnimalIntoForm(animal: AnimalModel): void {
    // Anderes Tier → Abgabegrund neu wählen (bei Wiederaufnahme gibt es andere Gründe).
    // Der Schritt-Kopf bleibt 'new', der Index bleibt damit auf "Allgemein".
    this.resetReasonState();
    this.updateSteps();
    this.resumeAnimal = animal;
    this.resumeAnimalSteps = true;
    const mapSimple: { formKey: string; animalKey: keyof AnimalModel }[] = [
      { formKey: 'sex', animalKey: 'sex' },
      { formKey: 'name', animalKey: 'name' },
      { formKey: 'nameOld', animalKey: 'nameOld' },
      { formKey: 'nameNew', animalKey: 'nameNew' },
      { formKey: 'birthPlace', animalKey: 'birthPlace' },
      { formKey: 'lifeNumber', animalKey: 'lifeNumber' },
      { formKey: 'petPassportNumber', animalKey: 'petPassportNumber' },
      { formKey: 'equinePassportNumber', animalKey: 'equinePassportNumber' },
      { formKey: 'ringNumber', animalKey: 'ringNumber' },
      { formKey: 'earTag', animalKey: 'earTag' },
      { formKey: 'tattoo', animalKey: 'tattoo' },
      { formKey: 'tattooLocation', animalKey: 'tattooLocation' },
      { formKey: 'coatColor', animalKey: 'coatColor' },
      { formKey: 'badge', animalKey: 'badge' },
      { formKey: 'specialNotice', animalKey: 'specialNotice' },
      { formKey: 'specialInformation', animalKey: 'specialInformation' },
      { formKey: 'breed', animalKey: 'breed' },
      { formKey: 'birthApprox', animalKey: 'birthApprox' }
    ];

    for (const { formKey, animalKey } of mapSimple) {
      const ctrl = this.formGroup.get(formKey);
      if (!ctrl) continue;

      const current = ctrl.value;
      const isEmpty =
        current === null ||
        current === undefined ||
        current === '' ||
        (Array.isArray(current) && current.length === 0);

      const valueFromAnimal = (animal as any)[animalKey];
      if (isEmpty && valueFromAnimal !== null && valueFromAnimal !== undefined) {
        ctrl.setValue(valueFromAnimal);
      }
    }

    this.resetAllFormFields(this.formGroup);
    const matchingFilter = this.categoryFilters.find(filter => {
      try {
        return this.mapFilterIdToCategory(filter.id) === this.resumeAnimal.category;
      } catch {
        return false;
      }
    });

    if (matchingFilter) {

      this.selectCategory(matchingFilter, false);
    } else {

      try {
        this.onCategoryChange({ value: this.resumeAnimal.category } as any);
      } catch {

      }
    }


    this.formGroup.patchValue(this.resumeAnimal);
    if (this.resumeAnimal.weight ?? null) {
      const w = this.resumeAnimal.weight;

      this.weightInput = w != null
        ? this.formatWeightInput(w / 1000)
        : null;
    } else {
      this.weightInput = null;
    }


    const birthdayCtrl = this.formGroup.get('birthday');
    if (birthdayCtrl && !birthdayCtrl.value && animal.birthday) {
      birthdayCtrl.setValue(new Date(animal.birthday));
    }

    const birthYearCtrl = this.formGroup.get('birthYear');
    if (birthYearCtrl && !birthYearCtrl.value && animal.birthYear) {

      birthYearCtrl.setValue(new Date(animal.birthYear));
    }


    const coatTypeCtrl = this.formGroup.get('coatType');
    if (coatTypeCtrl) {
      const current = coatTypeCtrl.value;
      const isEmpty = !current || (Array.isArray(current) && current.length === 0);
      if (isEmpty && animal.coatType) {
        coatTypeCtrl.setValue(animal.coatType);
      }
    }

  }

  onDuplicateDialogCancel(): void {
    this.resumeDuplicateDialogVisible = false;
    this.resumeDuplicateCandidates = [];
    this.resumeDuplicateSourceField = null;

    this.resetWizard();
    this.searchTerm = '';
    this.animalSearchResult = [];
  }

  onDuplicateDialogResume(animal: AnimalModel): void {
    this.resumeDuplicateDialogVisible = false;
    this.resumeDuplicateCandidates = [];
    this.resumeDuplicateSourceField = null;

    this.mergeResumeAnimalIntoForm(animal);
  }

  formatWeightInput(val: number | null): number | null {
    if (val === null || val === undefined) return null;

    return Number(val.toFixed(3));
  }

  formatpickUpDateTime(value: string | Date): string {
    const date = value instanceof Date ? value : new Date(value);
    const dd = date.getDate().toString().padStart(2, '0');
    const mo = (date.getMonth() + 1).toString().padStart(2, '0');
    const hh = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');
    return `${dd}.${mo}.${date.getFullYear()} ${hh}:${mm}`;
  }

  onWeightInput(event: any) {
    const value = event.target.value;
    this.weightInput = value;

    const valid = /^(\d{0,6}([,.]\d{0,3})?)?$/.test(value);
    if (!valid) {
      this.weightInputInvalid = true;
      this.formGroup.get('weight')?.setValue(null);
      return;
    }

    const normalized = value.replace(',', '.');
    const num = parseFloat(normalized);

    const nachkommastellen = (normalized.split('.')[1] || '').length;
    if (isNaN(num) || nachkommastellen > 3) {
      this.weightInputInvalid = true;
      this.formGroup.get('weight')?.setValue(null);
    } else {
      this.weightInputInvalid = false;
      this.formGroup.get('weight')?.setValue(num);
    }
  }


  private clearOriginContacts(): void {
    this.originContacts = [];
    this.activeOriginContactPanelIndex = '0';
  }

  addOriginContact(type: OriginContactType = AnimalContactTypeEnum.GIVER): void {
    const vm = this.createEmptyOriginContact(type);


    if (this.originContacts.length === 0) {
      vm.ref.isPrimary = true;
    }

    this.originContacts = [...this.originContacts, vm];
    this.activeOriginContactPanelIndex = (this.originContacts.length - 1).toString();
    this.cdr.markForCheck();
  }

  removeOriginContact(index: number): void {
    if (index < 0 || index >= this.originContacts.length) return;

    const next = this.originContacts.filter((_, i) => i !== index);


    if (next.length > 0 && !next.some(x => x.ref.isPrimary)) {
      next[0] = { ...next[0], ref: { ...next[0].ref, isPrimary: true } };
    }

    this.originContacts = next;
    this.syncActiveOriginContactPanel(index);
    this.cdr.markForCheck();
  }

  private syncActiveOriginContactPanel(removedIndex: number): void {
    if (this.originContacts.length === 0) {
      this.activeOriginContactPanelIndex = '0';
      return;
    }

    // Number(null) waere 0 und wuerde ein Panel aufklappen, das vorher zu war.
    if (this.activeOriginContactPanelIndex == null) return;

    const current = Number(this.activeOriginContactPanelIndex);
    if (!Number.isInteger(current) || current === removedIndex) {
      this.activeOriginContactPanelIndex = null;
      return;
    }

    const shifted = current > removedIndex ? current - 1 : current;
    this.activeOriginContactPanelIndex = Math.min(shifted, this.originContacts.length - 1).toString();
  }

  onOriginContactTypeChanged(index: number, type: OriginContactType): void {
    const next = [...this.originContacts];
    const cur = next[index];
    if (!cur) return;

    next[index] = { ...cur, ref: { ...cur.ref, type } };
    this.originContacts = next;
    this.cdr.markForCheck();
  }

  onOriginContactLabelChanged(index: number, label: string): void {
    const cur = this.originContacts[index];
    if (!cur) return;
    cur.ref.label = label;
    this.cdr.markForCheck();
  }


  onOriginValidationChanged(index: number, valid: boolean): void {
    const next = [...this.originContacts];
    const cur = next[index];
    if (!cur) return;

    next[index] = { ...cur, isValid: valid };
    this.originContacts = next;
    this.cdr.markForCheck();
  }

  onOriginNewContactUpdated(index: number, contact: ContactModel): void {
    const next = [...this.originContacts];
    const cur = next[index];
    if (!cur) return;

    next[index] = { ...cur, contact, isExisting: !!contact?.id };
    this.originContacts = next;
    this.cdr.markForCheck();
  }

  onOriginExistingSelected(index: number, contact: ContactModel): void {
    const next = [...this.originContacts];
    const cur = next[index];
    if (!cur) return;

    next[index] = { ...cur, contact, isExisting: !!contact?.id };
    this.originContacts = next;
    this.cdr.markForCheck();
  }

  onSearch() {
    this.searchTermChanged.next(this.searchTerm);
  }

  openFoundAnimal(animal: AnimalModel): void {
    this.resumeAnimalStep(animal);

    this.wizardEntry = 'foundExisting';
    this.applyReason(this.reasonsForTransfer.FOUND_ANIMAL);

    this.activeTabIndex = 1;
    this.cdr.markForCheck();
  }

  createAnimalFromTransponderSearch(): void {
    const value = this.searchTerm?.trim();
    if (!value) return;
    this.prefillTransponderNumber = value;
    this.addNewAnimalStep();

  }

  createAnimalFromBookNumberSearch(): void {
    const value = this.searchTerm?.trim();
    if (!value) return;
    this.prefillBookNumber = value;
    this.addNewAnimalStep();

  }

  addMotherAnimal(animal: AnimalModel) {
    if (!this.formGroup.contains('motherId')) {
      this.formGroup.addControl('motherId', new FormControl<number | null>(null, Validators.required));
    }
    this.formGroup.get('motherId')?.setValue(animal.id);
    this.selectedMother = animal;
  }

  getTabContent() {
    switch (this.items[this.activeTabIndex]?.label) {
      case 'Suche':
        return 'search';
      case 'Kategorie':
        return 'category';
      case 'Allgemein':
        return 'general';
      case 'Abgabegrund':
        return 'reasonForDelivery';
      case 'Herkunft':
      case 'Fundtieranzeige':
        return 'origin';
      case 'Sicherstellung':
        return 'securing';
      case 'PDF':
        return 'pdf';
      case 'Unterschriften':
        return 'signatures';
      default:
        return '';
    }
  }

  /**
   * Setzt nur Kategorie und Tierart – alle übrigen Eingaben bleiben erhalten,
   * damit ein Zurück zur Kategorie (oder ein Wechsel im Dropdown) nichts löscht.
   * Die Art wird nur ersetzt, wenn sie nicht zur neuen Kategorie passt.
   */
  selectCategory(filter: AnimalFilter, nextStep: boolean) {
    const category = this.mapFilterIdToCategory(filter.id);
    this.selectedCategory = filter;

    if (category) {
      this.formGroup.get('category')?.setValue(category);

      this.animalTypeOptions = this.filterAnimalTypesByCategory(category);

      const typeCtrl = this.formGroup.get('type');
      if (!this.animalTypeOptions.some(option => option.value === typeCtrl?.value)) {
        typeCtrl?.setValue(this.animalTypeOptions[0]?.value ?? null);
      }

      if (nextStep) {
        this.nextStep();
      }
    }
  }

  handleBarcodeTransponderScanned(event: { field?: string; value: string }) {
    const field = event.field;
    const code = event.value;

    if (!field) {
      console.warn('Kein Feld übergeben für Barcode:', code);
      return;
    }
    const input = document.getElementById(field) as HTMLInputElement;
    if (input) {
      input.value = code;
    }
    const idx = Number(field.split('_')[1]);
    this.transponderNumbers.at(idx).setValue(code);
  }

  handleBarcodeScanned(event: { field?: string; value: string }) {
    if (event.field) {
      this.formGroup.get(event.field)?.setValue(event.value);
    }
  }

  onCompetentAuthorityCreated(newAuthority: CompetentAuthorityModel): void {
    this.originCompetentAuthorityOptions = [
      ...this.originCompetentAuthorityOptions,
      newAuthority
    ];

    this.formGroup.get('originCompetentAuthority')?.setValue(newAuthority.id);
  }

  mapFilterIdToCategory(id: string): AnimalCategory | undefined {
    const categoryMap: { [key: string]: AnimalCategory } = {
      dog: AnimalCategory.DOG,
      cat: AnimalCategory.CAT,
      horse: AnimalCategory.HORSE,
      small_animal: AnimalCategory.SMALL_ANIMAL,
      reptile: AnimalCategory.REPTILE,
      wild_animal: AnimalCategory.WILD_ANIMAL,
      farm_animal: AnimalCategory.FARM_ANIMAL
    };

    return categoryMap[id.toLowerCase()];
  }

  filterAnimalTypesByCategory(category: AnimalCategory): AnimalTypeModel[] {
    const animalCategoryTypeMap: Record<AnimalCategory, AnimalType[]> = {
      [AnimalCategory.DOG]: [AnimalType.DOG],
      [AnimalCategory.CAT]: [AnimalType.CAT],
      [AnimalCategory.HORSE]: [AnimalType.HORSE, AnimalType.DONKEY, AnimalType.PONY, AnimalType.MULE],
      [AnimalCategory.SMALL_ANIMAL]: [
        AnimalType.HAMSTER, AnimalType.FERRET, AnimalType.RODENT, AnimalType.HARE, AnimalType.MARTEN,
        AnimalType.TENREC, AnimalType.CHICKEN, AnimalType.DUCK, AnimalType.GOOSE, AnimalType.GUINEA_PIG,
        AnimalType.CHINCHILLA, AnimalType.DEGU, AnimalType.WATERFOWL, AnimalType.ORNAMENTAL_BIRD, AnimalType.PARRET
      ],
      [AnimalCategory.REPTILE]: [
        AnimalType.TURTLE, AnimalType.LIZARD, AnimalType.SNAKE, AnimalType.SPIDER, AnimalType.SQUAMATE
      ],
      [AnimalCategory.WILD_ANIMAL]: [
        AnimalType.BEAR, AnimalType.ELK, AnimalType.HEDGEHOG,
        AnimalType.BIRD_OF_PREY, AnimalType.SONGBIRD, AnimalType.WATERBIRD, AnimalType.RED_WILD, AnimalType.BLACK_WILD,
        AnimalType.RACCOON, AnimalType.CANIDS, AnimalType.FELIDS, AnimalType.CORVIDS, AnimalType.AMPHIBIAN,
        AnimalType.PIGEON
      ],
      [AnimalCategory.FARM_ANIMAL]: [
        AnimalType.SHEEP, AnimalType.PIG, AnimalType.GOAT, AnimalType.COW, AnimalType.REINDEER, AnimalType.CAMEL,
        AnimalType.RATITE, AnimalType.ALPACA, AnimalType.CHICKEN
      ]
    };

    const allowedTypes = [
      ...(animalCategoryTypeMap[category] || []),
      AnimalType.UNKNOWN
    ];

    return this.allAnimalTypes.filter(typeModel =>
      allowedTypes.includes(typeModel.value as AnimalType)
    );
  }


  onCategoryChange(category: any) {
    const filter = this.categoryFilters.find(filter => filter.id.toLowerCase() === category.value.toLowerCase());
    if (filter) {
      this.selectCategory(filter, false);
    }
  }

  isSelectedCategory(filter: AnimalFilter) {
    return this.selectedCategory === filter;
  }

  reasonGiven(reason: string) {
    // Gleicher Grund (z. B. nach Zurück-Navigation) → Eingaben behalten und weiter.
    if (this.reasonGivenSet !== reason) {
      this.applyReason(reason);
    }
    this.nextStep();
  }

  private applyReason(reason: string): void {
    this.resetReasonState();

    this.reasonGivenSet = reason;
    this.formGroup.get('originType')?.setValue(reason);

    this.foundAnimalMode = (reason === this.reasonsForTransfer.FOUND_ANIMAL);
    this.securedByPoliceMode = (reason === this.reasonsForTransfer.SECURED_BY_POLICE);

    if (this.foundAnimalMode) {
      this.applyFoundModeState({ pdfRequired: false });
      this.addOriginContact(AnimalContactTypeEnum.FINDER);
    } else if (this.securedByPoliceMode) {
      this.updateOriginValidators();
      this.applySecuredModeState();
      this.addOriginContact(AnimalContactTypeEnum.OWNER);
    } else {
      this.applyFoundModeState({ pdfRequired: false });
    }

    this.updateSteps();
  }


  private applySecuredModeState(): void {
    this.updateFoundStatusValidators(this.formGroup.get('foundStatus')?.value as FoundStatus | null);
    this.updateBcsValidators();

    const enableKeys = ['signatureLocation', 'signatureDate', 'employeeSignature', 'handoverPartySignature'] as const;
    for (const key of enableKeys) {
      const ctrl = this.formGroup.get(key);
      if (!ctrl) continue;
      ctrl.enable({ emitEvent: false });
      ctrl.clearValidators();
      ctrl.updateValueAndValidity({ emitEvent: false });
    }
    if (!this.formGroup.get('signatureDate')?.value) {
      this.formGroup.get('signatureDate')?.setValue(new Date(), { emitEvent: false });
    }

    this.cdr.markForCheck();
  }

  private resetSecuringFields(): void {
    this.formGroup.patchValue({
      handoverAuthority: null,
      handoverResponsibleContact: null,
      ownerPresentAtHandover: false,
      securingReason: null,
      securingReasonOther: null,
      incidentCourse: null,
      operationDescription: null,
      biteVictimType: null,
      biteVictimGender: null,
      biteVictimAge: null,
      housingConditionsDescription: null,
      otherAnimalsLeftOnSite: false,
      otherAnimalsDescription: null,
      handedOverEquipment: null,
      handoverHealthStatus: [],
      needsImmediateVetCare: false,
      healthDescription: null,
      behaviourAtHandover: null,
      operationStartAt: null,
      operationEndAt: null,
      handoverPartySignature: null,
      presentShelterStaff: [],
    }, { emitEvent: false });
  }

  get securingSignaturesSaved(): boolean {
    if (!this.securedByPoliceMode) return true;

    const handoverParty = this.formGroup.get('handoverPartySignature')?.value;
    const employee = this.formGroup.get('employeeSignature')?.value;

    return !!handoverParty && !!employee;
  }

  get securingSectionInvalid(): boolean {
    if (!this.securedByPoliceMode) return false;

    const locationMissing = !this.formGroup.get('originLocation')?.value;
    const dateMissing = !this.formGroup.get('dateOfReceipt')?.value;
    const authorityMissing = !this.formGroup.get('handoverAuthority')?.value;
    const reasonsMissing = !this.formGroup.get('securingReason')?.value;

    return locationMissing || dateMissing || authorityMissing || reasonsMissing || !this.allFilledContactsValid();
  }

  updateOriginValidators(): void {
    const reason = this.reasonGivenSet;
    const isFoundAnimal = reason === this.reasonsForTransfer.FOUND_ANIMAL;

    this.setRequiredValidator('foundDateTime', isFoundAnimal);
    this.setRequiredValidator('originLocation', isFoundAnimal);
    this.setRequiredValidator('dateOfReceipt', !!reason && !isFoundAnimal);
    this.setRequiredValidator(
      'originCompetentAuthority',
      isFoundAnimal ||
      reason === this.reasonsForTransfer.TAKE_AWAY ||
      reason === this.reasonsForTransfer.WILD_FOUND
    );
  }

  private setRequiredValidator(name: string, required: boolean): void {
    const ctrl = this.formGroup.get(name);
    if (!ctrl) return;

    if (required) {
      ctrl.setValidators([Validators.required]);
    } else {
      ctrl.clearValidators();
    }
    ctrl.updateValueAndValidity({ emitEvent: false });
  }

  private applyFoundModeState(opts?: { pdfRequired?: boolean }): void {
    const pdfRequired = !!opts?.pdfRequired;

    this.updateFoundStatusValidators(this.formGroup.get('foundStatus')?.value as FoundStatus | null);

    this.updateBcsValidators();

    this.updateOriginValidators();

    const optionalKeys = ['foundSituation', 'reportPdfPath'] as const;
    for (const key of optionalKeys) {
      const ctrl = this.formGroup.get(key);
      if (!ctrl) continue;

      if (this.foundAnimalMode) {
        ctrl.enable({ emitEvent: false });
        ctrl.clearValidators();
      } else {
        ctrl.clearValidators();
        ctrl.setValue(null, { emitEvent: false });
        ctrl.disable({ emitEvent: false });
      }
      ctrl.updateValueAndValidity({ emitEvent: false });
    }

    const pdfKeys = ['signatureLocation', 'signatureDate', 'finderSignature', 'employeeSignature'] as const;
    for (const key of pdfKeys) {
      const ctrl = this.formGroup.get(key);
      if (!ctrl) continue;

      if (this.foundAnimalMode) {
        ctrl.enable({ emitEvent: false });

        if (pdfRequired) {
          ctrl.setValidators([Validators.required]);
        } else {
          ctrl.clearValidators();
        }
      } else {
        ctrl.clearValidators();
        ctrl.setValue(null, { emitEvent: false });
        ctrl.disable({ emitEvent: false });
      }

      ctrl.updateValueAndValidity({ emitEvent: false });
    }

    this.cdr.markForCheck();
  }

  private isPdfBlockValid(): boolean {
    if (!this.foundAnimalMode) return true;

    const emp = this.formGroup.get('employeeSignature')?.value;
    const fin = this.formGroup.get('finderSignature')?.value;
    const loc = this.formGroup.get('signatureLocation')?.value;
    const dat = this.formGroup.get('signatureDate')?.value;

    return !!(emp && fin && loc && dat);
  }

  private hasFilledContact(vm: OriginContactVm): boolean {
    return !!vm.contact && Object.keys(vm.contact).length > 0;
  }

  private allFilledContactsValid(): boolean {
    const filled = (this.originContacts ?? []).filter(vm => this.hasFilledContact(vm));
    return filled.every(vm => vm.isValid);
  }


  get isOriginContactsInvalidForReason(): boolean {
    const filled = (this.originContacts ?? []).filter(vm => this.hasFilledContact(vm));

    if (this.reasonGivenSet === this.reasonsForTransfer.FOUND_ANIMAL) {
      return filled.length === 0 || !this.allFilledContactsValid();
    }

    return !this.allFilledContactsValid();
  }


  private isBcsValid(): boolean {
    return (
      this.formGroup.get('careCondition')?.valid &&
      this.formGroup.get('bcsNutrition')?.valid &&
      this.formGroup.get('temperament')?.valid
    ) ?? false;
  }

  private buildOriginContactEntries(): OriginContactEntry[] {
    return (this.originContacts ?? [])
      .filter(vm => this.hasFilledContact(vm))
      .map(vm => ({
        meta: {
          id: (vm.ref as any)?.id,
          type: vm.ref.type,
          label: vm.ref.label ?? null,
          isPrimary: !!vm.ref.isPrimary,
        },
        data: {
          contact: vm.contact as ContactModel,
          isValid: vm.isValid ?? true,
          allowEmptyValid: (vm as any).allowEmptyValid ?? false,
        }
      }));
  }

  private hasAtLeastOneValidContact(): boolean {
    const filled = (this.originContacts ?? []).filter(vm => this.hasFilledContact(vm));

    if (this.foundAnimalMode) {
      return filled.length > 0 && filled.every(x => x.isValid);
    }

    return filled.every(x => x.isValid);
  }

  getInvalidFormControls(): boolean {
    const invalidControls = Object.keys(this.formGroup.controls).filter(
      key => this.formGroup.controls[key].invalid
    );

    const contactsOk = this.hasAtLeastOneValidContact();

    const ok =
      invalidControls.length === 0 &&
      contactsOk;

    if (this.foundAnimalMode && this.getTabContent() === 'signatures' && !this.isPdfBlockValid()) {
      return false;
    }

    return ok;
  }

  get currentBirthday(): string | null {
    const isYearOnly = this.formGroup.get('birthdayType')?.value;
    const dateValue = isYearOnly
      ? this.formGroup.get('birthYear')?.value
      : this.formGroup.get('birthday')?.value;

    if (!dateValue) return null;

    return this.datePipe.transform(dateValue, 'yyyy-MM-dd');
  }

  onYearOnlyChanged(value: boolean) {
    this.isYearOnlyFlag = value;
    this.formGroup.get('birthdayType')?.setValue(value);
  }

  onDelayedBirthdayChange(date: string) {
    setTimeout(() => this.onBirthdayChange(date), 0);
  }

  onBirthdayChange(date: string) {
    if (this.isYearOnlyFlag) {
      const match = /^\d{4}-01-01$/.exec(date);
      if (match) {
        const year = +date.split('-')[0];
        const lastDayOfYear = new Date(year, 11, 31);
        this.formGroup.get('birthYear')?.setValue(lastDayOfYear);
      } else {
        this.formGroup.get('birthYear')?.setValue(null);
      }
      this.formGroup.get('birthday')?.reset();
    } else {
      const validDate = new Date(date);
      if (!isNaN(validDate.getTime())) {
        this.formGroup.get('birthday')?.setValue(validDate);
      } else {
        this.formGroup.get('birthday')?.setValue(null);
      }
      this.formGroup.get('birthYear')?.reset();
    }
  }

  saveChanges(openDuplicateAfterSave: boolean = false, openSendAfterSave: boolean = false) {
    this.formSubmitted = true;

    if (this.formGroup.invalid || this.weightInputInvalid) {
      return;
    }

    if (!this.animalShelterId) {
      console.error('No animalShelterId found');
      return;
    }

    this.formGroup.patchValue({ animalShelter: { id: this.animalShelterId } });

    this._waittingDialogService.showWaitingDialog(true);

    const weightVal = this.formGroup.get('weight')?.value;
    if (weightVal !== null && weightVal !== undefined && weightVal !== '') {
      this.formGroup.patchValue({ weight: weightVal });
    } else {
      this.formGroup.patchValue({ weight: null });
    }

    if (this.formGroup.get('motherId')?.value) {
      this.formGroup.addControl('mother', new FormControl<{} | null>(null));
      this.formGroup.patchValue({ mother: { id: this.formGroup.get('motherId')?.value } });
      this.formGroup.removeControl('motherId');
    }

    const oldBookNumberArray = this.formGroup.get('oldBookNumberList') as FormArray;
    if (oldBookNumberArray && oldBookNumberArray.length > 0) {
      const sanitizedList = oldBookNumberArray.controls
        .map(ctrl => (ctrl.value ?? '').toString().trim())
        .filter(v => v !== '')
        .map(v => this._helperService.sanitizeOldBookNumber(v));

      while (oldBookNumberArray.length > 0) {
        oldBookNumberArray.removeAt(0);
      }
      sanitizedList.forEach(v => oldBookNumberArray.push(new FormControl(v)));
    }

    if (this.resumeAnimalSteps) {
      const updateAnimalPayload: any = {
        id: this.resumeAnimal.id,
        animalShelter: { id: this.animalShelterId },
        category: this.formGroup.get('category')?.value?.id ?? this.resumeAnimal.category,
        type: this.formGroup.get('type')?.value?.id ?? this.resumeAnimal.type,
        breed: this.formGroup.get('breed')?.value ?? this.resumeAnimal.breed,
        petPassportNumber: this.formGroup.get('petPassportNumber')?.value ?? this.resumeAnimal.petPassportNumber,
        equinePassportNumber: this.formGroup.get('equinePassportNumber')?.value ?? this.resumeAnimal.equinePassportNumber,
        lifeNumber: this.formGroup.get('lifeNumber')?.value ?? this.resumeAnimal.lifeNumber,
        transponderNumber: this.formGroup.get('transponderNumber')?.value ?? this.resumeAnimal.transponderNumber,
        oldBookNumberList: this.formGroup.get('oldBookNumberList')?.value ?? this.resumeAnimal.oldBookNumberList,
        sex: this.formGroup.get('sex')?.value ?? this.resumeAnimal.sex,
        name: this.formGroup.get('name')?.value ?? this.resumeAnimal.name,
        nameOld: this.formGroup.get('nameOld')?.value ?? this.resumeAnimal.nameOld,
        nameNew: this.formGroup.get('nameNew')?.value ?? this.resumeAnimal.nameNew,
        size: this.formGroup.get('size')?.value ?? this.resumeAnimal.size,
        weight: this.formGroup.get('weight')?.value ?? this.resumeAnimal.weight,
        birthday: this.formGroup.get('birthday')?.value ?? this.resumeAnimal.birthday,
        birthYear: this.formGroup.get('birthYear')?.value ?? this.resumeAnimal.birthYear,
        birthPlace: this.formGroup.get('birthPlace')?.value ?? this.resumeAnimal.birthPlace,
        specialInformation: this.formGroup.get('specialInformation')?.value ?? this.resumeAnimal.specialInformation,
        internalDetails: this.formGroup.get('internalDetails')?.value ?? this.resumeAnimal.internalDetails,
        externalDetails: this.formGroup.get('externalDetails')?.value ?? this.resumeAnimal.externalDetails,
        tattoo: this.formGroup.get('tattoo')?.value ?? this.resumeAnimal.tattoo,
        tattooLocation: this.formGroup.get('tattooLocation')?.value ?? this.resumeAnimal.tattooLocation,
        ringNumber: this.formGroup.get('ringNumber')?.value ?? this.resumeAnimal.ringNumber,
        earTag: this.formGroup.get('earTag')?.value ?? this.resumeAnimal.earTag,
        externalShortDescription: this.formGroup.get('externalShortDescription')?.value ?? this.resumeAnimal.externalShortDescription,
        externalDescription: this.formGroup.get('externalDescription')?.value ?? this.resumeAnimal.externalDescription,
        castrated: this.formGroup.get('castrated')?.value ?? this.resumeAnimal.castrated,
        castratedDate: this.formGroup.get('castratedDate')?.value ?? this.resumeAnimal.castratedDate,
        castratedNote: this.formGroup.get('castratedNote')?.value ?? this.resumeAnimal.castratedNote,
        chemicalCastratedDate: this.formGroup.get('chemicalCastratedDate')?.value ?? this.resumeAnimal.chemicalCastratedDate,
        sterilized: this.formGroup.get('sterilized')?.value ?? this.resumeAnimal.sterilized,
        sterilizedDate: this.formGroup.get('sterilizedDate')?.value ?? this.resumeAnimal.sterilizedDate,
        websiteUrl: this.formGroup.get('websiteUrl')?.value ?? this.resumeAnimal.websiteUrl,
        syncWithWebsite: this.formGroup.get('syncWithWebsite')?.value ?? this.resumeAnimal.syncWithWebsite,
        websiteMetaTitle: this.formGroup.get('websiteMetaTitle')?.value ?? this.resumeAnimal.websiteMetaTitle,
        websiteMetaDescription: this.formGroup.get('websiteMetaDescription')?.value ?? this.resumeAnimal.websiteMetaDescription,
        sanctuary: this.formGroup.get('sanctuary')?.value ?? this.resumeAnimal.sanctuary,
        fosterHomeWanted: this.formGroup.get('fosterHomeWanted')?.value ?? this.resumeAnimal.fosterHomeWanted
      };

      if (this.formGroup.get('motherId')?.value || this.resumeAnimal.motherId) {
        updateAnimalPayload.mother = { id: this.formGroup.get('motherId')?.value ?? this.resumeAnimal.motherId };
      }

      if (openDuplicateAfterSave && !openSendAfterSave) {
        this.setupDuplicateAfterOriginCreated(this.resumeAnimal.id);
      }


      this._animalRepository.update(this.resumeAnimal.id, updateAnimalPayload)
        .subscribe({
          next: () => {
            this.animal = this.resumeAnimal;
            this._animalAddService.saveOrigin(
              this.formGroup.getRawValue(),
              this.resumeAnimal.id,
              this.buildOriginContactEntries()
            );
            if (!openDuplicateAfterSave && !openSendAfterSave) {
              this._toast.showSuccess(
                this._translateService.translate('animalAdd.toast.saveSuccess')
              );
              this.closeModal();
            }
          },
          error: (error) => {
            console.error('Error saving animal:', error);
            this._waittingDialogService.showWaitingDialog(false);
            this.restoreOldBookNumberInputs();
          }
        });

    } else {
      this._animalRepository.create(this.formGroup.value)
        .subscribe({
          next: newAnimal => {
            if (newAnimal.id === undefined || newAnimal.id === null) return;

            if (openDuplicateAfterSave) {
              this.setupDuplicateAfterOriginCreated(newAnimal.id);
            }
            this.animal = newAnimal;
            this._animalAddService.saveOrigin(
              this.formGroup.getRawValue(),
              newAnimal.id,
              this.buildOriginContactEntries()
            );

            if (!openDuplicateAfterSave && !openSendAfterSave) {
              this._toast.showSuccess(
                this._translateService.translate('animalAdd.toast.saveSuccess')
              );
              this.closeModal();
            }
          },
          error: (error) => {
            console.error('Error saving animal:', error);
            this._waittingDialogService.showWaitingDialog(false);
            this.restoreOldBookNumberInputs();
          }
        });
    }
  }

  /**
   * saveChanges() baut die Buchnummern-Liste vor dem Senden neu auf. Schlägt das Speichern fehl
   * (z. B. Buchnummer schon vergeben), muss sie im Schritt "Allgemein" wieder korrigierbar sein.
   */
  private restoreOldBookNumberInputs(): void {
    if (this.oldBookNumberList.length === 0) {
      this.oldBookNumberList.push(new FormControl(''));
    }
    this.updateOldBookNumberDisabledStates();
  }

  onDialogHide(): void {
    if (this.skipCloseOnHide) {
      this.skipCloseOnHide = false;




      if (this.pendingFoundDuplicate) {
        this.pendingFoundDuplicate = false;
        this.foundDuplicateMode = true;
        this.cdr.markForCheck();
      }
      return;
    }

    this.closeModal();
  }

  hideWithoutDestroy(): void {
    this.skipCloseOnHide = true;
    this.visible = false;
  }


  onDuplicateClosed() {
    this.duplicateAnimalDialogVisible = false;
    this.duplicateOrigin = null;
    this.animal = null;

    this.closeModal();
  }

  /**
   * Startet aus dem Step "Fundtieranzeige" den Mehrfach-Fundtier-Prozess.
   * Zeigt zuerst eine Bestätigung, dass die Original-Daten korrekt gepflegt sind
   * (danach am Original keine Änderungen mehr möglich).
   */
  openFoundDuplicate(): void {
    if (!this.animalShelterId) {
      return;
    }

    this._confirmationService.confirm({
      header: this._translateService.translate('animalAdd.foundDuplicate.confirm.header'),
      message: this._translateService.translate('animalAdd.foundDuplicate.confirm.message'),
      acceptLabel: this._translateService.translate('animalAdd.foundDuplicate.confirm.accept'),
      rejectLabel: this._translateService.translate('modal.cancel'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.startFoundDuplicate(),
    });
  }

  /**
   * Übergibt das Wizard-Tier (ohne vorher zu speichern) als gesperrtes Original an die
   * duplicate-animals-Komponente. Es wird dort nicht editiert, aber für PDF + Speichern genutzt.
   */
  private startFoundDuplicate(): void {
    if (!this.animalShelterId) {
      return;
    }

    const fv = this.formGroup.getRawValue();

    const baseAnimal: AnimalModel = {
      ...(this.resumeAnimalSteps && this.resumeAnimal ? this.resumeAnimal : {}),
      ...fv,
      animalShelter: { id: this.animalShelterId } as any,
    } as AnimalModel;

    if (!baseAnimal.name && this.resumeAnimalSteps) {
      baseAnimal.name = this.resumeAnimal?.name ?? null;
    }

    const baseOrigin: AnimalOriginModel = {
      dateOfReceipt: null,
      foundDateTime: fv.foundDateTime ?? null,
      location: fv.originLocation ?? null,
      specialInformation: fv.originSpecialInformation ?? null,
      otherComments: fv.originOtherComments ?? null,
      type: this.reasonsForTransfer.FOUND_ANIMAL,
      foundStatus: fv.foundStatus ?? null,
      careCondition: fv.careCondition ?? [],
      bcsNutrition: fv.bcsNutrition ?? null,
      temperament: fv.temperament ?? [],
      animalShelter: { id: this.animalShelterId } as any,
      shelterChanged: false,
    } as any;

    this.foundDuplicateShared = {
      shelterId: this.animalShelterId,
      foundStatus: fv.foundStatus ?? null,

      foundDateTime: fv.foundDateTime ?? null,
      pickupUserName: fv.pickupUserName ?? null,
      pickUpDateTime: fv.pickUpDateTime ?? null,
      consentToShareWithOwner: !!fv.consentToShareWithOwner,
      competentAuthorityId: fv.originCompetentAuthority ?? null,
      signatureLocation: fv.signatureLocation ?? null,
      signatureDate: fv.signatureDate ?? null,
      contacts: this.buildOriginContactEntries(),
      authorityContacts: this.originCompetentAuthorityOptions.find(a => a.id === fv.originCompetentAuthority)?.contacts ?? [],
      originalOriginId: null,
    };

    this.animal = baseAnimal;
    this.foundDuplicateAnimal = baseAnimal;
    this.foundDuplicateOrigin = baseOrigin;



    this.pendingFoundDuplicate = true;
    this.hideWithoutDestroy();
    this.cdr.markForCheck();
  }

  onFoundDuplicateClosed(): void {
    this.foundDuplicateMode = false;
    this.foundDuplicateAnimal = null;
    this.foundDuplicateOrigin = null;
    this.foundDuplicateShared = null;
    this.animal = null;

    this.closeModal();
  }

  setupDuplicateAfterOriginCreated(animalId: number) {
    this._animalAddService.originCreated$
      .pipe(
        filter(e => e.animalId === animalId),
        take(1)
      )
      .subscribe(({ origin }) => {
        const formValues = this.formGroup.value as any;

        const baseAnimal: any =
          this.resumeAnimalSteps && this.resumeAnimal
            ? { ...this.resumeAnimal }
            : {};

        const duplicateAnimal: AnimalModel = {
          ...baseAnimal,
          ...formValues,
          id: animalId,
          animalShelter: { id: this.animalShelterId! } as any,
        } as AnimalModel;


        const duplicateOrigin: AnimalOriginModel = {
          dateOfReceipt: origin.dateOfReceipt,
          location: origin.location ?? null,
          specialInformation: origin.specialInformation ?? null,
          otherComments: origin.otherComments ?? null,
          type: origin.type ?? null,
          careCondition: origin.careCondition ?? null,
          bcsNutrition: origin.bcsNutrition ?? null,
          temperament: origin.temperament ?? null,
          contacts: (origin.contacts ?? []).map(c => ({ ...c })),
          animalShelter: origin.animalShelter ?? { id: this.animalShelterId! } as any,
          shelterChanged: false,
        } as any;

        this.animal = duplicateAnimal;
        this.duplicateOrigin = duplicateOrigin;

        this.hideWithoutDestroy();
        this.duplicateAnimalDialogVisible = true;

        this._toast.showSuccess(
          this._translateService.translate('animalAdd.toast.saveSuccess')
        );
      });
  }

  onCastratedDatesChange() {
    const castratedDate = this.formGroup.get('castratedDate')?.value;
    const chemicalCastratedDate = this.formGroup.get('chemicalCastratedDate')?.value;

    if (castratedDate || chemicalCastratedDate) {
      this.formGroup.get('castrated')?.setValue(true);
    } else {
      this.formGroup.get('castrated')?.setValue(false);
    }
  }

  saveAndSendFoundReport(): void {
    this.setupSendAfterOriginCreated();
    this.saveChanges(false, true);
  }

  private setupSendAfterOriginCreated(): void {
    this._animalAddService.originCreated$
      .pipe(take(1))
      .subscribe(({ origin }) => {
        this.sendFoundReportOriginId = origin.id;
        const authorityId = this.formGroup.get('originCompetentAuthority')?.value;
        const authority = this.originCompetentAuthorityOptions.find(a => a.id === authorityId);
        this.sendFoundReportContacts = authority?.contacts ?? [];
        this.hideWithoutDestroy();
        this.sendFoundReportDialogVisible = true;
        this._toast.showSuccess(
          this._translateService.translate('animalAdd.toast.saveSuccess')
        );
        this.cdr.markForCheck();
      });
  }

  onSendFoundReportClosed(): void {
    this.sendFoundReportDialogVisible = false;
    this.closeModal();
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
